import { forwardRef, useImperativeHandle, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import dayjs from "dayjs";
import { toast } from "sonner";

import { CModal } from "src/1/common/components/others";
import { CDate, CInput, CSelect } from "src/common/components/controls";

import { khoTrungTamApi } from "_1/apis/kho_trung_tam.api";

import {
  KY_DANH_GIA_OPTIONS,
  YEAR_OPTIONS,
} from "../../../phieu_cham_diem_nha_cung_cap/constants";

const defaultValues = {
  cycle: 1,
  year: 2026,
  evaluation_date: dayjs().toDate(),
  note: "",
};

export const TaoPhieuChamDiemKTT = forwardRef(({ refetch }, ref) => {
  //#region Data
  const [open, setOpen] = useState(false);

  const {
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = useForm({
    defaultValues,
  });
  //#endregion

  //#region Event
  const onClose = () => {
    setOpen(false);
    reset(defaultValues);
  };

  const onSubmit = handleSubmit(async (values) => {
    try {
      await khoTrungTamApi.create(values);
      toast.success("Đã lưu thông tin phiếu");
      refetch();
      onClose();
    } catch (error) {
      toast.error(error?.message || "Tạo phiếu không thành công");
    }
  });
  //#endregion

  useImperativeHandle(ref, () => ({
    open: () => setOpen(true),
  }));

  //#region Render
  return (
    <CModal
      open={open}
      onClose={onClose}
      title="Tạo phiếu chấm điểm KTT"
      loading={isSubmitting}
      onSubmit={onSubmit}
    >
      <div className="grid grid-cols-2 gap-4">
        <Controller
          control={control}
          name="cycle"
          render={({ field: { onChange, ..._field } }) => (
            <CSelect
              {..._field}
              required
              select="value"
              label="Kỳ đánh giá"
              options={KY_DANH_GIA_OPTIONS ?? []}
            />
          )}
        />
        <Controller
          control={control}
          name="year"
          render={({ field: { onChange, ..._field } }) => (
            <CSelect
              {..._field}
              required
              select="value"
              label="Năm"
              options={YEAR_OPTIONS ?? []}
            />
          )}
        />
        <Controller
          control={control}
          name="evaluation_date"
          render={({ field }) => (
            <CDate {...field} required label="Ngày đánh giá" />
          )}
        />
        <Controller
          control={control}
          name="note"
          render={({ field }) => <CInput {...field} required label="Ghi chú" />}
        />
      </div>
    </CModal>
  );
  //#endregion
});
